import React, { Component, Fragment } from 'react';
import background from '../../../theme/images/30MEDubai-The_Opus_Pool.jpg';
import { Link } from 'react-router-dom'
import $ from 'jquery';
import { setIdRotateDeg } from '../../action/autoCheckin';
import { connect } from 'react-redux';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import {withTranslation} from 'react-i18next'
class PicturePreview extends Component{

    constructor(props){
        super(props)
        this.state = {
            rotateDeg:0
        }
    }

    rotateImageHandler = (rotateDeg) => {

        const img_cont = $("#image_preview_cont")[0];
        const img = $("#image_preview")[0];

        let deg = (rotateDeg + 90) % 360;

        if(deg === 90 || deg === 270){
            img_cont.style.height = "500px";
            img.style.objectFit = "contain";
        }else{
            img_cont.style.height = "100%";
            img.style.objectFit = "cover";
        }

        img.style.transform = `rotate(${deg}deg)`;
        this.setState({rotateDeg:deg});
        this.props.setIdRotateDeg(deg);
    }

    componentDidUpdate(){
        mobileCheckinColorConfig(this.props.menuColor);
    }
    

    componentDidMount() {
        mobileCheckinColorConfig(this.props.menuColor);
      }

    

    render(){
        const {t} = this.props
        return(
            <div className="main-container picture-preview" style={{background: `${background} center center no-repeat`, backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
               
                <section className="widgets padding-0 margin-0 container-bg" style={{overflow:"hidden", minHeight: '80vh', backgroundColor: '#000 !important', display:"flex", alignItems:"center"}}>
                    {this.props.video ? <video height = "400" src={this.props.image} controls>
                        {t('camera.video_tag err')}
                    </video> 
                    
                    :<div id = "image_preview_cont" style = {{width:"100%",height:"100%"}}>
                        <img id = "image_preview" src = {`${this.props.image}`} alt = "selected image" style = {{width:'100%', height:"100%" ,objectFit: 'cover'}}/>
                </div>}
                {!this.props.selfie && <i onClick = {() => this.rotateImageHandler(this.state.rotateDeg)} class="fas fa-sync-alt" style = {{color:"#000",background:"rgba(255,255,255,0.5)",padding:"5px", borderRadius:"50%" ,fontSize:"25px",position:"fixed",top:"10px",right:"10px",zIndex:"5"}}></i>}
                </section>
                <footer className="button-controls footer-overlay picture-preview">
                    <section className="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                   
                        {/* <p class="heading">{t("camera.picture_preview_heading")}</p> */}
                        <p class="subheading">{this.props.selfie ? t('camera.selfie_is_ok') : t('camera.picture_is_ok')}</p>
                        {this.props.switchUsingNextScreen ?
                              <button onClick={this.props.nextScreen} className="primary w-100 all-caps">{this.props.video ? t('camera.save_the_video') : t('camera.save_the_photo')}</button>
                        // : (<Link  exact to={`${this.props.nextPath}`}>
                            : <button className="primary w-100 all-caps" onClick = {this.props.hidePicturePreview}>{this.props.video ? t('camera.save_the_video') : t('camera.save_the_photo')}</button>
                        //    </Link>)
                    }
                        
                        <button onClick = {this.props.backBtn} className="secondary w-100 all-caps margin-top-1" 
                        >{t('camera.take_another')}</button>
                    </section>
                </footer>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor
    }
}

export default connect(mapStateToProps,{ setIdRotateDeg })(withTranslation('translations')(PicturePreview));